<app-header class="Apphead"></app-header>
<section class=" text-light  p-5 p-lg-2" style="background-color: black;">
    <div class="container-fluid">
        <div class="d-sm-flex align-items-center justify-content-center ">
            <div style="width: 50vw;" class="fade-effect">
                <h1>
                    Transform your traditional business to
                    <span class="text-warning ">
                        digital.
                    </span>
                </h1>
                <p class="my-4  d-none d-lg-block">
                    Digital transformation helps an organisation keep up with emerging customer demands and therefore survive in the face of the future. It allows companies to compete better in an economic environment that is constantly changing in response to technology
                    evolutions.
                </p>
                <a href="#contactus" class="my-4">
                    <button class="btn bg-warning text-light ">Contact us</button>
                </a>
            </div>
            <div>
                <img src="../../assets/img/illustration-1.png " alt=" " class="img-fluid art">
            </div>
        </div>

    </div>
</section>
<!-- section 2 -->
<section class="text-light p-5 " style="background-color: #0067B8; ">
    <div class="container-fluid">
        <div class="d-sm-flex align-items-center justify-content-center ">

            <div>
                <img src="../../assets/img/illustration-2.png " alt=" " class="img-fluid jump">
            </div>
            <div class="fade-effect">
                <h1 class="mt-sm-5 ">

                    Experience the growth benfit of Digital business.

                </h1>
                <p class="my-2 ">

                    We take care of technology part of your buisness model.
                </p>
                <a href="Product" class="link">
                    <button class="btn bg-danger text-light ">Explore our products</button>
                </a>

            </div>
        </div>
    </div>

</section>
<!-- section 3 -->
<section class="text-dark p-5 " id="contactus" style="background-color: white; ">
    <div class="container ">
        <div class="d-sm-flex align-items-center justify-content-center ">
            <div>
                <h1 class="mb-5 text-center ">
                    Contact us

                </h1>
                <div class="container " style="width: 40vw; ">
                    <div class="row my-2 ">
                        <div class="col ">
                            <div class="d-flex ">
                                <img src="../../assets/img/mail.png " width="30 " height="30 " />
                                <p class="px-2 ">email</p>
                            </div>
                        </div>
                        <div class="col ">
                            <a href="mailto:jackpaul3413@gmail.com ">jackpaul3413@gmail.com</a>
                        </div>
                    </div>
                    <div class="row my-2 ">
                        <div class="col ">
                            <div class="d-flex ">
                                <img src="../../assets/img/phone.png " width="30 " height="30 " />
                                <p class="px-2 ">Tel</p>
                            </div>
                        </div>
                        <div class="col ">
                            <a href="tel:+918428184922 ">+918428184922</a>
                        </div>
                    </div>
                    <div class="row my-2 ">
                        <div class="col ">
                            <div class="d-flex ">
                                <img src="../../assets/img/address.png " width="30 " height="30 " />
                                <p class="px-2 ">Venue</p>
                            </div>
                        </div>
                        <div class="col ">
                            <p>11/A, Thamarai avenue, N.T.Patel Road, Nerkundram, Chennai, TamilNadu, India Pincode: 600107.</p>
                        </div>
                    </div>

                </div>
            </div>
            <div>
                <img src="../../assets/img/illustration-3.png " alt=" " class="img-fluid d-sm-block d-none">
            </div>

        </div>
    </div>

</section>

<app-footer class="AppFooter"></app-footer>